import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updateDepartmentTodo = createAsyncThunk('updateDepartment', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `department/${data?.id}`,
            data: {
                "name": data.department,
                "status": data.status,
                // "modified_by": localStorage.getItem('userId')
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('token')
            }
        });

        // ✅ Return only serializable fields
        return res

    } catch (error) {
        return error?.response
    }
});
